import { render, staticRenderFns } from "./RatingDialog.vue?vue&type=template&id=90dae9da&scoped=true"
import script from "./RatingDialog.vue?vue&type=script&lang=ts"
export * from "./RatingDialog.vue?vue&type=script&lang=ts"
import style0 from "./RatingDialog.vue?vue&type=style&index=0&id=90dae9da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dae9da",
  null
  
)

export default component.exports